import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import Selectsearch from "react-select";
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   allStudents,
   fetchORTChippingReport,
   fetchORTBunkerReport,
   fetchORTWedgeReport,
   fetchORTShortGameReport,
   fetchORTIronReport,
   fetchORTDrivingReport,
   fetchORTLongGameReport,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';


import ChippingChart from './component/chippingchart';
import BunkerChart from './component/bunkerchart';
import WedgeChart from './component/wedgechart';
import ShortGameChart from './component/shortgamechart';
import IronChart from './component/ironchart';
import DrivingChart from './component/drivingchart';
import LongGameChart from './component/longgamechart';


class onrangechart extends Component {
   
   constructor(props) {
      
      super(props);
      let startDate = new Date();
      let befrstart=new Date(startDate.setMonth(startDate.getMonth() - 2));
      this.confirmationDialog = React.createRef();
         this.state = {
            student:'',
            startdate:befrstart,
            enddate:new Date(),
            viewdiv1:true,
            viewdiv2:false,
            viewdiv3:true,
            viewdiv4:true,
            loader:false,   
            frm:1,     
         };  
   } 

   UNSAFE_componentWillMount() {
	   this.props.allStudents();
	} 

   selstudent(evt){
        var student=evt.value;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        var contact='';
        var area='';
        var distance='';
        var shot='';
        this.setState({ 
            loader:true,
            student: student,  
            viewdiv2:false,
        });
        this.props.fetchORTLongGameReport(student, stdate, eddate, distance, shot, area, contact);
        this.props.fetchORTDrivingReport(student, stdate, eddate, distance, area, contact);
        this.props.fetchORTIronReport(student, stdate, eddate, distance, area, contact);
        this.props.fetchORTShortGameReport(student, stdate, eddate, shot, area, contact);
        this.props.fetchORTWedgeReport(student, stdate, eddate, distance, area, contact);
        this.props.fetchORTBunkerReport(student, stdate, eddate, area, contact);
        this.props.fetchORTChippingReport(student, stdate, eddate, shot, area, contact).then((data) => {   
                    
            this.setState({ 
                loader:false,
                viewdiv2:true,  
            });

        });
        
    }

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    handleSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        var contact='';
        var area='';
        var shot='';
        var distance='';
        this.setState({ 
            loader:true,
            viewdiv2:false,
        });
        this.props.fetchORTLongGameReport(student, stdate, eddate, distance, shot, area, contact);
        this.props.fetchORTDrivingReport(student, stdate, eddate, distance, area, contact);
        this.props.fetchORTIronReport(student, stdate, eddate, distance, area, contact);
        this.props.fetchORTShortGameReport(student, stdate, eddate, shot, area, contact);
        this.props.fetchORTWedgeReport(student, stdate, eddate, distance, area, contact);
        this.props.fetchORTBunkerReport(student, stdate, eddate, area, contact);
        this.props.fetchORTChippingReport(student, stdate, eddate, shot, area, contact).then((data) => {   
            var resdata=data.data;            
            this.setState({ 
                loader:false,
                viewdiv2:true,  
            });

        });
    }   

   

    render() {
      const { match, studentlists, loading } = this.props;

      const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
      });

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>On Range Report | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.orchartview" />} match={match} />
             <div className="row">
                        <div className="col-sm-12 col-lg-4">
                            <RctCollapsibleCard> 
                                <div className="row">                                        
                                    <div className="col-sm-12 col-lg-12"> 
                                        <FormGroup>
                                            <Label for="Select">Student *</Label>
                                            <Selectsearch id="student" name="student" placeholder="Select Student *" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selstudent(evt)} required/>
                                        </FormGroup>
                                    </div>                                     
                                </div>
                            </RctCollapsibleCard>  
                        </div>
                        {this.state.viewdiv1 &&                             
                            <div className="col-sm-12 col-lg-6">
                                <RctCollapsibleCard>                              
                                    <form autoComplete="off" id="addform" onSubmit={(e)=>this.handleSubmit(e)}>              
                                        <div className="row">                                                    
                                            <div className="col-lg-5">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                            selected={this.state.startdate}
                                                            onChange={this.selectstart}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown 
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="col-lg-5">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                            selected={this.state.enddate}
                                                            onChange={this.selectend}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="form-group">                       
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter"/>                                            
                                            </div>              
                                        </div>
                                    </form>  
                                </RctCollapsibleCard>                                                    
                            </div>
                        }
                </div>
               {this.state.viewdiv2 && 
                 <>
                 <ChippingChart data={this.state}/>
                 <BunkerChart data={this.state}/>
                 <WedgeChart data={this.state}/>
                 <ShortGameChart data={this.state}/>
                 <IronChart data={this.state}/>
                 <DrivingChart data={this.state}/>
                 <LongGameChart data={this.state}/>
                 </>
               }

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }

               {this.state.viewdiv3 && 
                <div className="row">    
                    {/* <div className="col-sm-12 col-lg-6">            
                        <TestChart />
                    </div>    */}
                    
                </div>
               }                  
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused }) => {
	const { studentlists, loading } = mostlyused;
	return { studentlists, loading };
}

export default connect(mapStateToProps, {
   allStudents,
   fetchORTChippingReport,
   fetchORTBunkerReport,
   fetchORTWedgeReport,
   fetchORTShortGameReport,
   fetchORTIronReport,
   fetchORTDrivingReport,
   fetchORTLongGameReport,
})(onrangechart); 